import Client from './client';

export default class GoogleShoppingSettings extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/settings/google`, options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/settings/google`, {
      ...options,
       method: 'POST',
    });
  }

}
